export const icons = [
	{
		name: "js",
		color: "yellow"
	},
	{
		name: "react",
		color: "blue"
	},
	{
		name: "node js",
		color: "green"
	},
	{
		name: "css3",
		color: "blue"
	},
	{
		name: "html5",
		color: "orange"
	},
	{
		name: "sass",
		color: "pink"
	},
	{
		name: "git",
		color: "red"
	},
	{
		name: "vuejs",
		color: "green"
	}
];
